export default __webpack_public_path__ + "img/allergy-lupin.2162ed35932f13732d8ef670844b12e8.svg";